import { SET_FORM_STATE } from '../actions/MopRanReportActions.js';

const initialState = {
	remove: []
};

const MopRanReportReducer = (state = initialState, action) => {
	switch (action.type) {
					case SET_FORM_STATE: {
						return {
							...state,
							remove: action.remove
						};
					}
					default: {
						return state;
					}
	}
};

export default MopRanReportReducer;
